"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = require("yup");
exports.default = Yup.object().shape({
    reason: Yup.string().required("Required"),
    accepted: Yup.boolean()
        .oneOf([true], "Do you certify that the information you entered is correct?")
        .required(),
});
